import { ExportableFilePopupSignatureSettings } from "@/ExportableFile/Api/Dto/ExportableFilePopupSignatureSettings";

class ExportableFilePopupSettings {
    public Form: ExportableFilePopupSignatureSettings;
    public Prescription: ExportableFilePopupSignatureSettings;
    public ExamRequest: ExportableFilePopupSignatureSettings;
    public ConsultationRequest: ExportableFilePopupSignatureSettings;

    public constructor(init?: Partial<ExportableFilePopupSettings>) {
        Object.assign(this, init);
    }
}

export { ExportableFilePopupSettings };
